import { CarrierDto, KnownSortOrder } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useCallback } from 'react';
import { createPath, Paths, ProjectPathParams } from '../../../../app/router/app.router';
import {
  InfiniteScrollProps,
  InfiniteTable,
  PaginatedRow
} from '../../../../ui/components/pure/list-table-wrappers/infinite-table.component';
import { CarriersListQueryParams } from '../logic/carriers-list-query.map';
import { useCarriersTable } from '../hooks/use-carriers-table.hook';
import { carrierCouriersProjectID } from '../logic/carriers-list-props.map';

type CarriersTableProps = {
  params: ProjectPathParams<Paths.carriers>;
  pages: PaginatedRow<CarrierDto>[];
  infiniteScroll: InfiniteScrollProps;
  setFormData: (update: Partial<CarriersListQueryParams>) => void;
  sortData: { sortBy: string; sortOrder: KnownSortOrder };
  isLoading: boolean;
  isPreviousData: boolean;
  hasError: boolean;
  customMessage: string;
};

export function CarriersTable({
  params,
  pages,
  infiniteScroll,
  setFormData,
  sortData,
  isLoading,
  isPreviousData,
  hasError,
  customMessage
}: CarriersTableProps) {
  const tb = useCarriersTable();

  // The viewer's project, not the carrier's — its container's project may not be readable by them.
  // A company's carrier is the exception: it has no detail page, so it opens its project's couriers.
  const mapRowURL = useCallback(
    (row: CarrierDto) => {
      const couriersProjectID = carrierCouriersProjectID(row);
      return couriersProjectID
        ? createPath(Paths.couriers, { projectID: couriersProjectID })
        : createPath(Paths.carrier, {
            projectID: params.shortcode || params.projectID,
            carrierID: row.id
          });
    },
    [params.projectID, params.shortcode]
  );
  tb.config({ mapRowURL });

  return (
    <InfiniteTable
      uniqueKey="id"
      onSort={setFormData}
      sortData={sortData}
      table={tb}
      pages={pages}
      infiniteScroll={infiniteScroll}
      isLoading={isLoading}
      isPreviousData={isPreviousData}
      hasError={hasError}
      customMessage={customMessage}
    />
  );
}
